import { render, staticRenderFns } from "./ArtistResults.vue?vue&type=template&id=31374c2a&"
import script from "./ArtistResults.vue?vue&type=script&lang=js&"
export * from "./ArtistResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports